/**
 * Convertiser Touchpoint + Global Cart Watcher for Shopify
 */

(function () {
  const DEBUG = false;

  const SALE_GOAL_ID = '42c63af1-19d0067a-14e837b9c4f3';
  const SUBSCRIPTION_GOAL_ID = 'f776099b-e9f5bf82-30eb3292643b';
  const CART_ATTR_KEY = 'convertiser';


  async function getCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Failed to fetch /cart.js');
    return res.json();
  }

  async function updateCartAttr(attrs) {
    DEBUG && console.log('[Convertiser] Updating cart attributes:', attrs);
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json;charset=UTF-8',
        'X-Convertiser-Update': 'true'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: attrs })
    });
  }

  function buildConvertiserAttr({ goal_id, metaCurrent }) {
    return JSON.stringify({
      goal_id,
      publisher_id: String(metaCurrent?.publisher_id ?? ''),
      publisher_subid: String(metaCurrent?.publisher_subid ?? ''),
      guid: String(metaCurrent?.guid ?? '')
    });
  }

  async function resolveGoalIdFromCart() {
    const cart = await getCart();
    const hasSubscription =
      Array.isArray(cart.items) &&
      cart.items.some(i => Boolean(i && i.selling_plan_allocation));
    DEBUG && console.log('[Convertiser] Cart subscription status:', hasSubscription);
    return hasSubscription && SUBSCRIPTION_GOAL_ID ? SUBSCRIPTION_GOAL_ID : SALE_GOAL_ID;
  }

  function debounce(fn, wait) {
    let t;
    return function (...args) {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  const reconcile = debounce(async function reconcileAttr() {
    try {
      DEBUG && console.log('[Convertiser] Reconciling cart attributes...');

      if (typeof window.touchpoint !== 'function') {
        DEBUG && console.log('[Convertiser] No touchpoint – clearing attribute');
        await updateCartAttr({ [CART_ATTR_KEY]: '' }).catch(() => {});
        return;
      }

      const attribution = touchpoint('getAttribution');
      if (!attribution || !attribution.current) {
        DEBUG && console.log('[Convertiser] No attribution – clearing attribute');
        await updateCartAttr({ [CART_ATTR_KEY]: '' }).catch(() => {});
        return;
      }

      if (attribution.current.source === 'convertiser') {
        DEBUG && console.log('[Convertiser] Attribution source = convertiser');
        const metaCurrent = touchpoint('getMetadata', attribution.current.url) || {};
        const goal_id = await resolveGoalIdFromCart();
        const convertiserAttr = buildConvertiserAttr({ goal_id, metaCurrent });

        DEBUG && console.log('[Convertiser] Setting attribute value:', convertiserAttr);
        await updateCartAttr({ [CART_ATTR_KEY]: convertiserAttr })
          .catch(err => console.warn('Convertiser -> cart attributes error', err));
      } else {
        DEBUG && console.log('[Convertiser] Attribution is not convertiser – clearing attribute');
        await updateCartAttr({ [CART_ATTR_KEY]: '' }).catch(() => {});
      }
    } catch (err) {
      console.warn('Convertiser reconcile error:', err);
    }
  }, 200);
    
  (function patchFetchForCart() {
    const originalFetch = window.fetch;
    window.fetch = async function patchedFetch(input, init = {}) {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      const method = (init && (init.method || 'GET')).toUpperCase();

      const isConvertiserUpdate = init?.headers && init.headers['X-Convertiser-Update'];

      const isCartMutation =
        /\/cart\/(add|change|update|clear)\b/.test(url) &&
        method !== 'GET' &&
        !isConvertiserUpdate;

      const response = await originalFetch(input, init);

      if (isCartMutation) {
        DEBUG && console.log('[Convertiser] Cart mutation detected:', url, method);
        Promise.resolve()
          .then(() => response.clone().json().catch(() => null))
          .finally(() => reconcile());
      }
      return response;
    };
  })();

  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = (form.getAttribute('action') || '').split('?')[0];
    if (/\/cart\/(add|change)(\.js)?$/.test(action)) {
      DEBUG && console.log('[Convertiser] Form submit detected:', action);
      setTimeout(reconcile, 300);
    }
  });

  document.addEventListener('touchpoint.ready', function () {
    DEBUG && console.log('[Convertiser] touchpoint.ready fired – initial reconcile');
    reconcile();
  });

  reconcile();
})();